import { ListOfEmployeeHolidayAccountResponse } from './Api/ListOfEmployeeHolidayAccount.response';

export class ListOfEmployeeHolidayAccountEntity extends ListOfEmployeeHolidayAccountResponse {
	public static tryCast(o: any) {
		return Object.assign(new ListOfEmployeeHolidayAccountEntity(), o);
	}
}
